import {
  isProductApprovalRejectedRow,
  resolveProductRejectReasonText,
} from '@/pages/NewproductInfoCenter/productApprovalFieldMeta';

/**
 * 审批驳回 UI 总开关（编辑模式 / 供应商）——仅约束产品 / 公司
 * true  = 编辑 / 供应商可见驳回原因（字段框、媒体条、上传弹层、页头横幅、左侧驳回感叹号）
 * false = 上述暂时隐藏（管理员「审批模式」不受影响）
 *
 * 广告不走此开关：详情横幅与字段驳回看 showAdRejectPanels / showAdminAdRejectPanels。
 */
export const SHOW_EDIT_SUPPLIER_REJECT_REASON = false;

/**
 * 编辑 / 供应商是否展示驳回相关 UI（供产品 / 公司及仍调用本方法的共用组件）
 * （与 showCompanyRejectPanels / showProductRejectPanels / showAdRejectPanels 一致）
 * - 整单已驳回(R)：显示
 * - 管理员审批模式 + 已审批(A)：显示（产品）
 * - 已审批 / 审批中等其它情况：不显示
 * - 受 SHOW_EDIT_SUPPLIER_REJECT_REASON 约束；广告业务请直接判断 showAdRejectPanels
 */
export function shouldShowEditSupplierRejectPanels(host) {
  if (!SHOW_EDIT_SUPPLIER_REJECT_REASON || !host) return false;
  const panels = host.showCompanyRejectPanels
    ?? host.showProductRejectPanels
    ?? host.showAdRejectPanels;
  return panels === true;
}

/** 待优化 / 左侧感叹号是否并入「字段驳回」（产品 / 公司；与 show*RejectPanels + 本文件总开关一致） */
export function shouldIncludeRejectHintsInTodo(host) {
  if (!host) return false;
  const panels = host.showCompanyRejectPanels
    ?? host.showProductRejectPanels
    ?? host.showAdRejectPanels;
  if (!panels) return false;
  return host.isApprovalMode || SHOW_EDIT_SUPPLIER_REJECT_REASON;
}

/**
 * 提交前是否应拦截：只看真正未填必填，不含字段驳回提示。
 * 左侧 menu 感叹号可同时表示「未填」与「驳回」，但提交不应被驳回框限制。
 */
export function tabHasSubmitBlockingUnfilled(host, tabItem) {
  return !!tabItem?._hasUnfilledRequired;
}

/**
 * 子项是否应在 UI 中视为「已驳回」：
 * - 管理员审批模式：只看 resultCode（0/2/4），不要求 rejectReason
 * - 编辑 / 供应商：resultCode 已驳回且驳回文案非空
 *
 * 用于：媒体角标、「查看 N 条驳回」、驳回详情弹窗、左侧 Tab 感叹号（字段驳回部分）。
 */
export function isVisibleApprovalRejectRow(row, host) {
  if (!row || !isProductApprovalRejectedRow(row)) return false;
  if (host?.isApprovalMode || host?.fromAdmin) return true;
  return !!String(resolveProductRejectReasonText(row.rejectReason) || '').trim();
}
